import { Component, EventEmitter, Input, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ParcelaDetalhe } from './detalhe-parcela.model';

@Component({
  selector: 'app-detalhe-parcela',
  templateUrl: './detalhe-parcela.component.html',
  styleUrls: ['./detalhe-parcela.component.css'],
  animations: [
    trigger('expandCollapse', [
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      transition('closed <=> open', animate('300ms ease'))
    ])
  ]
})
export class DetalheParcelaComponent {
  @Input() aberto = false;
  @Input() parcela: ParcelaDetalhe;
  @Output() fechar = new EventEmitter<void>();

  onFechar(): void {
    this.fechar.emit();
  }

  trackByNumero(index: number): number {
    return index;
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  }

  totalizarCampo(campo: 'valorPrincipal' | 'jurosRemuneratorios' | 'jurosMoratorios' | 'multa' | 'iof'): number {
    if (!this.parcela || !this.parcela.pagamentosParciais) {
      return 0;
    }

    return this.parcela.pagamentosParciais
      .reduce((total, pagamento) => total + (pagamento[campo] || 0), 0);
  }

  getDescricaoParcela(): string {
    return 'Essa parcela está sendo paga parcialmente. Sempre que entrar saldo na sua conta, o valor é usado para reduzir o que falta pagar, e os juros são cobrados só sobre o valor restante.';
  }
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-extrato-cli/components/detalhe-parcela/detalhe-parcela.component.ts